import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'mt-4 flex w-full flex-col gap-3',
    title: 'heading-xs font-[450]',
    ratingsContainer: 'flex flex-col gap-2',
    ratingButton: 'flex cursor-pointer items-center justify-center gap-5',
    rating: 'flex w-7.5 items-center gap-1',
    ratingValue: 'heading-xs',
    star: 'text-icon-star flex size-6 items-center justify-center',
    starIcon: '[&>path]:fill-brand-400',
    count: 'heading-xs w-9 text-right',
    ratingBar: 'relative grow',
    ratingBarLine:
      'bg-bg-items-secondary absolute inset-x-0 top-1/2 h-px -translate-y-1/2 rounded-full',
    ratingBarFill:
      'absolute top-1/2 h-[3px] -translate-y-1/2 rounded-full bg-[#072939]'
  },
  variants: {
    selected: {
      true: {
        ratingValue: '!font-[450]',
        starIcon: '[&>path]:fill-brand-300'
      }
    }
  }
});
